<script>
    import { createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition';
    import Modal from './Modal.svelte'

    export let title
    export let leftAlign = false
    let ctrlsDisabled = false

    const dispatch = createEventDispatcher ();
    const outcome = (eventId) => {
        ctrlsDisabled = true;
        dispatch (eventId)
    }
</script>

<style>
    .basic-panel-content {
        text-align: center;
        position: relative;
        z-index: 2;
    }
    .basic-panel-content.left-align {
        text-align: left;
    }
    .basic-panel-content .heading {
        font-size: 16px;
    }
    .ctrls {
        margin-top: 10px;
        text-align: left;
        position: relative;
        z-index: 1;
    }
    .ctrls :global(button) {
        padding: .40rem 1.3rem;
    }
    .ctrls :global(.btn) {
        margin-right: 5px;
    }
</style>

<Modal> <!-- overlayBg="rgba(62, 79, 90, 0.8)" -->
    <div class="basic-panel-content" class:left-align={leftAlign}>
        <div class="heading">{title || 'Foobar title?'}</div>
        <slot></slot>
    </div>
    <div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
        <button class="btn btn-sm btn-primary" disabled={ctrlsDisabled} on:click={() => outcome ('confirm')}>Conferma</button>
        <button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={() => outcome ('cancel')}>Annulla</button>
    </div>
</Modal>